import SVGIcon, { type SVGIconProps } from "@ch/components/Icons/SVGIcon";
import type { FC } from "react";

type MoreOptionsIconProps = Partial<SVGIconProps>;

const MoreOptionsIcon: FC<MoreOptionsIconProps> = (props) => (
  <SVGIcon viewBox="0 0 4 11" {...props}>
    <circle
      cx="2.26953"
      cy="5.75"
      fill="currentColor"
      r="0.625"
      stroke="currentColor"
      strokeLinecap="round"
      strokeWidth="0.5"
      transform="rotate(90 2.26953 5.75)"
    />
    <circle
      cx="2.26953"
      cy="2"
      fill="currentColor"
      r="0.625"
      stroke="currentColor"
      strokeLinecap="round"
      strokeWidth="0.5"
      transform="rotate(90 2.26953 2)"
    />
    <circle
      cx="2.26953"
      cy="9.5"
      fill="currentColor"
      r="0.625"
      stroke="currentColor"
      strokeLinecap="round"
      strokeWidth="0.5"
      transform="rotate(90 2.26953 9.5)"
    />
  </SVGIcon>
);

export default MoreOptionsIcon;
